import React from 'react';

import P1Welcome from './pantallas/P1_Welcome';
import P2DatosBasicos from './pantallas/P2_DatosBasicos';
import P3Raza from './pantallas/P3_Raza';
import P4Peso from './pantallas/P4_Peso';
import P5Actividad from './pantallas/P5_Actividad';
import P6ComidaApetito from './pantallas/P6_ComidaApetito';
import P7Alergias from './pantallas/P7_Alergias';
import P8Salud from './pantallas/P8_Salud';
import P9Reveal from './pantallas/P9_Reveal';

import Step10RecetasV2 from '../steps/Step10_Recetas_v2';
import Step11TuPlan from '../steps/Step11_TuPlan';
import Step12ComoEmpezar from '../steps/Step12_ComoEmpezar';
import Step12Extras from '../steps/Step12_Extras';
import Step13Checkout from '../steps/Step13_Checkout';

export const FUNNEL_ORDER: Record<number, React.FC> = {
  1: P1Welcome,
  2: P2DatosBasicos,
  3: P3Raza,
  4: P4Peso,
  5: P5Actividad,
  6: P6ComidaApetito,
  7: P7Alergias,
  8: P8Salud,
  9: P9Reveal,
  10: Step10RecetasV2,
  11: Step11TuPlan,
  12: Step12ComoEmpezar,
  13: Step12Extras,
  14: Step13Checkout,
};

export const TOTAL_PANTALLAS = 14;
